@if (projectState) {
  @if (projectState === 'submitting-project') {
    <div
      class="flex flex-col justify-center items-center h-64 gap-8 success-check-container"
    >
      <img src="../../../../../assets/images/ai-initiate-assistant.gif" />
      <div>
        <p class="text-center">Your request is being processed...</p>
        <span>Please keep this window open while we process your request</span>
      </div>
    </div>
  }
  @if (projectState === 'submitted-project') {
    <div
      class="flex flex-col justify-center items-center h-64 gap-4 success-check-container"
    >
      <mat-icon class="success-check-icon">check_circle</mat-icon>
      <div>
        <p class="text-center">
          Thanks for requesting additional recruitment support!
        </p>
        <p class="text-center secondary-text">
          We'll reach out with next steps at our earliest availability
        </p>
      </div>
      <button mat-stroked-button color="primary" (click)="closeDialog(true)">
        Done
      </button>
    </div>
  }
  @if (projectState === 'failed-submission') {
    <div
      class="flex flex-col justify-center items-center h-64 gap-8 success-check-container"
    >
      <mat-icon class="failed-check-icon">error</mat-icon>
      <div>
        <p class="text-center">
          Something went wrong and your request wasn't submitted
        </p>
        <p class="text-center secondary-text">
          Please try again, or contact customersupport&#64;techspert.com for
          help
        </p>
      </div>
      <button mat-stroked-button color="primary" (click)="closeDialog(false)">
        Close
      </button>
    </div>
  }
} @else {
  <div
    class="flex justify-between content-center"
    data-test-id="request-recruitment-dialog"
  >
    <span mat-dialog-title data-test-id="request-recruitment-dialog-title">
      Get recruitment support
    </span>
    <button mat-icon-button (click)="closeDialog(false)">
      <mat-icon data-test-id="request-recruitment-dialog-close">clear</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <form class="flex flex-col gap-8" [formGroup]="detailsForm">
      <div formArrayName="segments" class="flex flex-col gap-4">
        <span class="font-medium"
          >Which segments do you need help with recruitment on?</span
        >
        @for (group of segmentsArray.controls; track group; let i = $index) {
          <div class="flex items-center gap-4" [formGroupName]="i">
            <mat-form-field class="w-2/3">
              <mat-label>Select segment</mat-label>
              <mat-select formControlName="segmentId">
                @for (seg of getAvailableSegments(i); track seg) {
                  <mat-option [value]="seg.opportunitySegmentId">
                    {{ seg.geography }} - {{ seg.segment }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label># experts needed</mat-label>
              <input
                matInput
                type="number"
                min="0"
                formControlName="recruitmentAmount"
              />
            </mat-form-field>
            <button mat-icon-button type="button" (click)="removeSegment(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
        <div class="flex gap-2">
          <button
            class="flex flex-auto"
            mat-stroked-button
            type="button"
            (click)="addSegment()"
          >
            <mat-icon>add</mat-icon>
            Add segment
          </button>
          <button
            class="flex flex-auto"
            mat-stroked-button
            type="button"
            (click)="addAllSegments()"
          >
            <mat-icon>add</mat-icon>
            Add all
          </button>
        </div>
        @if (submitted && segmentsArray.hasError('required')) {
          <mat-error> At least one segment must be selected </mat-error>
        }
      </div>
      <mat-form-field>
        <mat-label
          >Tell us more about the experts you’d like us to recruit</mat-label
        >
        <textarea matInput formControlName="recruitmentCriteria"></textarea>
        <mat-hint
          >Please include details such as: areas of expertise or roles of
          interest, any honorarium limits, exclusion criteria, engagement
          length, and any pre/post work
        </mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Timelines</mat-label>
        <textarea matInput formControlName="timelines"></textarea>
        <mat-hint
          >When should we get started? When do you need recruitment completed
          by?</mat-hint
        >
      </mat-form-field>
      <div class="file-upload-container">
        <div class="outlined-file-upload">
          <label for="transcriptFile" class="file-upload-label">
            Upload supporting materials
          </label>
          <input
            id="transcriptFile"
            type="file"
            class="file-upload-input"
            (change)="onFilesAdd($event.target)"
          />
          <mat-hint>
            Please upload any screeners, guidelines or background material you’d
            like us to use
          </mat-hint>
          @if (files.length > 0) {
            <ul class="uploaded-files">
              @for (file of files; track file) {
                <li class="file-item">
                  <span>{{ file.name }} ({{ file.size | bytes }})</span>
                  <button
                    mat-icon-button
                    type="button"
                    (click)="removeFile($index)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      </div>
      <mat-form-field>
        <mat-label>Next steps</mat-label>
        <mat-select formControlName="nextSteps" multiple>
          <mat-option value="Kick off immediately"
            >Kick off immediately</mat-option
          >
          <mat-option value="Book a kick-off call"
            >Book a kick-off call</mat-option
          >
          <mat-option value="Share feasibility and pricing"
            >Share feasibility and pricing</mat-option
          >
        </mat-select>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="flex gap-2">
    <button
      mat-stroked-button
      class="flex-1 primaryColor-border"
      (click)="closeDialog(false)"
    >
      Cancel
    </button>
    <button mat-flat-button class="flex-1" color="primary" (click)="submit()">
      Submit
    </button>
  </mat-dialog-actions>
}
